import { AgentDetailSection, AgentDetailSectionEnum } from "../../../../../agentDetail.model";

export const AGENT_DETAIL_TABS: { key: AgentDetailSection; label: string }[] = [
    { key: AgentDetailSectionEnum.PERSONAL_INFORMATION, label: "Personal Information" },
    { key: AgentDetailSectionEnum.BUSINESS_INFORMATION, label: "Business Info" },
    { key: AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION, label: "Contract / Licensing" },
];

export const DEFAULT_AGENT_DETAIL_TAB: AgentDetailSection = AgentDetailSectionEnum.PERSONAL_INFORMATION;

export const AGENT_DETAIL_TAB_SLUGS: Record<AgentDetailSection, string> = {
    [AgentDetailSectionEnum.PERSONAL_INFORMATION]: "personal-info",
    [AgentDetailSectionEnum.BUSINESS_INFORMATION]: "business-info",
    [AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION]: "contract-licensing",
};

const TAB_SLUG_TO_SECTION = Object.fromEntries(
    Object.entries(AGENT_DETAIL_TAB_SLUGS).map(([section, slug]) => [slug, section])
) as Record<string, AgentDetailSection>;

export function getAgentDetailTabFromSlug(slug: string | null): AgentDetailSection {
    return (slug && TAB_SLUG_TO_SECTION[slug]) || DEFAULT_AGENT_DETAIL_TAB;
}
